import { Key } from "react";
import { Fade, FadeProps } from "react-awesome-reveal";
import styled from "styled-components";

export const CascadingText = (props: FadeProps & { key?: Key }) => {
  return (
    <FadeWrapper
      delay={0}
      cascade
      damping={5e-2}
      {...props}
      key={props.key}
      style={{
        ...props.style,
      }}
      $whiteSpace={props?.style?.whiteSpace ?? "pre"} // doesn't work without !important
    >
      {props.children}
    </FadeWrapper>
  );
};

interface FadeWrapperProps {
  $whiteSpace: string; //by default Fade has text in one line (whiteSpace: pre)
}

const FadeWrapper = styled(Fade)<FadeWrapperProps>`
  white-space: ${(props) => props.$whiteSpace} !important;
  width: unset !important;
`;
